export const RS_CHANCE_2 = {
  titleTable: "LOTO CHANCE",
  descriptionTable: "DRAW [number] NUMBERS + [bonus] BONUS",
  descriptionKeyNumber: "5",
  descriptionKeyBonus: "2",
  colspan: "2",
  dataTableHeader: [
    { title: "CHANCE [number]", key: "2" },
    { title: "MULTIPLIER", key: "" },
  ],
  dataTableContent: [
    {
      number: "[number] numbers",
      numberKey: "2",
      bonusKey: "",
      multiplier: "150",
    },
    {
      number: "1 numéro + [bonus] bonus",
      numberKey: "1",
      bonusKey: "1",
      multiplier: "15",
    },
    {
      number: "0 numbers + [bonus] bonus",
      numberKey: "0",
      bonusKey: "2",
      multiplier: "15",
    },
    {
      number: "[number] numéro",
      numberKey: "1",
      bonusKey: "",
      multiplier: "1",
    },
    {
      number: "0 numéro + [bonus] bonus",
      numberKey: "0",
      bonusKey: "1",
      multiplier: "1",
    },
  ],
};

export const RS_CHANCE_3 = {
  titleTable: "",
  descriptionTable: "",
  descriptionKeyNumber: "",
  descriptionKeyBonus: "",
  dataTableHeader: [
    { title: "CHANCE [number]", key: "3" },
    { title: "MULTIPLIER", key: "" },
  ],
  dataTableContent: [
    {
      number: "[number] numbers",
      numberKey: "3",
      bonusKey: "",
      multiplier: "2,000",
    },
    {
      number: "[number] numbers + [bonus] bonus",
      numberKey: "2",
      bonusKey: "1",
      multiplier: "60",
    },
    {
      number: "1 numéro + [bonus] bonus",
      numberKey: "1",
      bonusKey: "2",
      multiplier: "60",
    },
    {
      number: "[number] numbers",
      numberKey: "2",
      bonusKey: "",
      multiplier: "40",
    },
    {
      number: "1 numéro + [bonus] bonus",
      numberKey: "1",
      bonusKey: "1",
      multiplier: "2",
    },
    {
      number: "0 numbers + [bonus] bonus",
      numberKey: "0",
      bonusKey: "2",
      multiplier: "2",
    },
    {
      number: "[number] numéro",
      numberKey: "1",
      bonusKey: "",
      multiplier: "1",
    },
  ],
};

export const RS_CHANCE_4 = {
  titleTable: "",
  descriptionTable: "",
  descriptionKeyNumber: "",
  descriptionKeyBonus: "",
  dataTableHeader: [
    { title: "CHANCE [number]", key: "4" },
    { title: "MULTIPLIER", key: "" },
  ],
  dataTableContent: [
    {
      number: "[number] numbers",
      numberKey: "4",
      bonusKey: "",
      multiplier: "10,000",
    },
    {
      number: "[number] numbers + [bonus] bonus",
      numberKey: "3",
      bonusKey: "1",
      multiplier: "1,000",
    },
    {
      number: "[number] numbers + [bonus] bonus",
      numberKey: "2",
      bonusKey: "2",
      multiplier: "1,000",
    },
    {
      number: "[number] numbers",
      numberKey: "3",
      bonusKey: "",
      multiplier: "200",
    },
    {
      number: "[number] numbers + [bonus] bonus",
      numberKey: "2",
      bonusKey: "1",
      multiplier: "40",
    },
    {
      number: "1 numéro + [bonus] bonus",
      numberKey: "1",
      bonusKey: "2",
      multiplier: "40",
    },
    {
      number: "[number] numbers",
      numberKey: "2",
      bonusKey: "",
      multiplier: "20",
    },
    {
      number: "[number] numéro",
      numberKey: "1",
      bonusKey: "",
      multiplier: "1",
    },
  ],
};

export const RS_CHANCE_5 = {
  titleTable: "",
  descriptionTable: "",
  descriptionKeyNumber: "",
  descriptionKeyBonus: "",
  dataTableHeader: [
    { title: "CHANCE [number]", key: "5" },
    { title: "MULTIPLIER", key: "" },
  ],
  dataTableContent: [
    {
      number: "[number] numbers",
      numberKey: "5",
      bonusKey: "",
      multiplier: "100,000",
    },
    {
      number: "[number] numbers + [bonus] bonus",
      numberKey: "4",
      bonusKey: "1",
      multiplier: "10,000",
    },
    {
      number: "[number] numbers + [bonus] bonus",
      numberKey: "3",
      bonusKey: "2",
      multiplier: "10,000",
    },
    {
      number: "[number] numbers",
      numberKey: "4",
      bonusKey: "",
      multiplier: "5,000",
    },
    {
      number: "[number] numbers + [bonus] bonus",
      numberKey: "3",
      bonusKey: "1",
      multiplier: "500",
    },
    {
      number: "[number] numbers + [bonus] bonus",
      numberKey: "2",
      bonusKey: "2",
      multiplier: "500",
    },
    {
      number: "[number] numbers",
      numberKey: "3",
      bonusKey: "",
      multiplier: "100",
    },
    {
      number: "[number] numbers + [bonus] bonus",
      numberKey: "2",
      bonusKey: "1",
      multiplier: "15",
    },
    {
      number: "[number] numbers",
      numberKey: "2",
      bonusKey: "",
      multiplier: "10",
    },
    {
      number: "[number] numéro",
      numberKey: "1",
      bonusKey: "",
      multiplier: "1",
    },
  ],
};
